import qs from 'qs';
import axios from 'axios';

const modalHandler = async (event) => {
	const qsParams = qs.stringify({ mediacode: event.detail.mediacode });
	const response = await axios.post(`/wp-ajax/?action=cig_get_publication_logo`, qsParams);
	const logoHtml = `<img src=${response.data.url} class="img-fluid" alt="logo">`;
	const elTitle = window.document.querySelector(event.detail.titleSelector);
	const elModalHeader = elTitle.closest('.modal-header');

	if (response.data.url !== null || response.data.url !== '') {
		if (response.data.backgroundColor) {
			elModalHeader.style.backgroundColor = response.data.backgroundColor;
		}
		elTitle.innerHTML = logoHtml;
	}
};

const addModalHandler = () => {
	const elBody = window.document.querySelector('body');
	elBody.addEventListener('cig.Modal.PaymentUpdate.open', modalHandler);
};

export default addModalHandler;
